import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import ItemType from "../../../containers/modules/master/item-type";

export default function ItemTypeRoute(props) {
  const { authUser } = props;
  return (
    <Route
        path="item-type"
        index
        element={
            <AccessControl
            name={"Item Type List"}
            auth={authUser}
            component={()=><ItemType authUser={authUser}></ItemType>}
            />
        }
        />
  );
}
